import { render } from "./OthersSummaryWidget.vue?vue&type=template&id=6ac9bdc7&scoped=true&ts=true"
import script from "./OthersSummaryWidget.vue?vue&type=script&lang=ts"
export * from "./OthersSummaryWidget.vue?vue&type=script&lang=ts"

import "./OthersSummaryWidget.vue?vue&type=style&index=0&id=6ac9bdc7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac9bdc7"]])

export default __exports__